import { DiceType } from './DiceModel';
import { Challenger } from '../types';
import { t } from '../i18n';

// 挑战者骰子配置
export interface ChallengerDiceConfig {
  id: string;
  nameKey: string;
  descKey: string;
  difficulty: 'easy' | 'medium' | 'hard';
  diceTypes: DiceType[];
  targetScore: number;
  rewardDice: DiceType[];
  rewardProbability: number;
  betAmount: number;
}

// 挑战者数据
export const CHALLENGER_CONFIGS: { [key: string]: ChallengerDiceConfig } = {
  'tou-ge': {
    id: 'tou-ge',
    nameKey: 'challenger.tou-ge.name',
    descKey: 'challenger.tou-ge.desc',
    difficulty: 'easy',
    diceTypes: [DiceType.ODD, DiceType.ODD, DiceType.NORMAL, DiceType.NORMAL, DiceType.NORMAL, DiceType.NORMAL],
    targetScore: 4000,
    rewardDice: [DiceType.ODD],
    rewardProbability: 0.7,
    betAmount: 50
  },
  'real-gambler': {
    id: 'real-gambler',
    nameKey: 'challenger.real-gambler.name',
    descKey: 'challenger.real-gambler.desc',
    difficulty: 'hard',
    diceTypes: [DiceType.ANGEL_AN, DiceType.ANGEL_JI, DiceType.ANGEL_LA, DiceType.DEMON_LU, DiceType.DEMON_XI, DiceType.DEMON_FA],
    targetScore: 4000,
    rewardDice: [DiceType.ANGEL_AN, DiceType.ANGEL_JI, DiceType.ANGEL_LA, DiceType.DEMON_LU, DiceType.DEMON_XI, DiceType.DEMON_FA],
    rewardProbability: 0.3,
    betAmount: 50
  },
  'dance-boss': {
    id: 'dance-boss',
    nameKey: 'challenger.dance-boss.name',
    descKey: 'challenger.dance-boss.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED],
    targetScore: 4000,
    rewardDice: [DiceType.CLOTHED],
    rewardProbability: 0.3,
    betAmount: 50
  },
  'cheater': {
    id: 'cheater',
    nameKey: 'challenger.cheater.name',
    descKey: 'challenger.cheater.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED],
    targetScore: 4000,
    rewardDice: [DiceType.RIGGED],
    rewardProbability: 0.4,
    betAmount: 50
  },
  'a-san': {
    id: 'a-san',
    nameKey: 'challenger.a-san.name',
    descKey: 'challenger.a-san.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE],
    targetScore: 3333,
    rewardDice: [DiceType.TRIPLE_THREE],
    rewardProbability: 0.33,
    betAmount: 33
  },
  'malcolm': {
    id: 'malcolm',
    nameKey: 'challenger.malcolm.name',
    descKey: 'challenger.malcolm.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.MINI, DiceType.MINI, DiceType.MINI, DiceType.NORMAL, DiceType.NORMAL, DiceType.NORMAL],
    targetScore: 6000,
    rewardDice: [DiceType.MINI],
    rewardProbability: 1,
    betAmount: 100
  },
  'merchant': {
    id: 'merchant',
    nameKey: 'challenger.merchant.name',
    descKey: 'challenger.merchant.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.SMALL_LUCKY, DiceType.SMALL_LUCKY, DiceType.SMALL_LUCKY, DiceType.LUCKY, DiceType.LUCKY, DiceType.LUCKY],
    targetScore: 6000,
    rewardDice: [DiceType.SMALL_LUCKY, DiceType.LUCKY],
    rewardProbability: 0.3,
    betAmount: 180
  },
  'small-cavier': {
    id: 'small-cavier',
    nameKey: 'challenger.small-cavier.name',
    descKey: 'challenger.small-cavier.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.CAVI_C, DiceType.CAVI_C, DiceType.CAVI_C, DiceType.CAVI_C, DiceType.CAVI_C, DiceType.CAVI_C],
    targetScore: 6000,
    rewardDice: [DiceType.CAVI_C],
    rewardProbability: 0.6,
    betAmount: 30
  },
  'enhance-a-san': {
    id: 'enhance-a-san',
    nameKey: 'challenger.enhance-a-san.name',
    descKey: 'challenger.enhance-a-san.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.ANTIOCH, DiceType.ANTIOCH, DiceType.ANTIOCH, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE],
    targetScore: 6000,
    rewardDice: [DiceType.ANTIOCH, DiceType.TRIPLE_THREE],
    rewardProbability: 0.33,
    betAmount: 33
  },
  'heaven-knight': {
    id: 'heaven-knight',
    nameKey: 'challenger.heaven-knight.name',
    descKey: 'challenger.heaven-knight.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.HEAVEN, DiceType.KNIGHT, DiceType.KNIGHT, DiceType.KNIGHT, DiceType.KNIGHT, DiceType.KNIGHT],
    targetScore: 8000,
    rewardDice: [DiceType.HEAVEN, DiceType.KNIGHT],
    rewardProbability: 0.3,
    betAmount: 200
  },
  'alonso': {
    id: 'alonso',
    nameKey: 'challenger.alonso.name',
    descKey: 'challenger.alonso.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.ADULT, DiceType.ADULT, DiceType.ADULT, DiceType.ADULT, DiceType.ADULT, DiceType.ADULT],
    targetScore: 8000,
    rewardDice: [DiceType.ADULT],
    rewardProbability: 0.2,
    betAmount: 300
  },
  'cavier': {
    id: 'cavier',
    nameKey: 'challenger.cavier.name',
    descKey: 'challenger.cavier.desc',
    difficulty: 'medium',
    diceTypes: [DiceType.CAVIER_1, DiceType.CAVIER_1, DiceType.CAVIER_1, DiceType.CAVIER_1, DiceType.CAVIER_1, DiceType.CAVIER_1],
    targetScore: 8000,
    rewardDice: [DiceType.CAVIER_1, DiceType.CAVIER_2, DiceType.CAVIER_3, DiceType.CAVIER_4, DiceType.CAVIER_5, DiceType.CAVIER_6],
    rewardProbability: 0.25,
    betAmount: 10
  }
};

// 获取所有挑战者数据
export const getAllChallengers = (): Challenger[] => {
  return Object.values(CHALLENGER_CONFIGS).map(config => ({
    id: config.id,
    name: t(config.nameKey),
    description: t(config.descKey),
    difficulty: config.difficulty,
    targetScore: config.targetScore
  }));
};

// 获取挑战者骰子配置
export const getChallengerDiceConfig = (challengerId: string): DiceType[] => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? config.diceTypes : Array(6).fill(DiceType.NORMAL);
};

// 获取挑战者名称
export const getChallengerName = (challengerId: string): string => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? t(config.nameKey) : t('challenger.unknown');
};

// 获取挑战者难度
export const getChallengerDifficulty = (challengerId: string): 'easy' | 'medium' | 'hard' => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? config.difficulty : 'medium';
};

// 获取挑战者目标分数
export const getChallengerTargetScore = (challengerId: string): number => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? config.targetScore : 4000;
};

// 获取挑战者奖励骰子
export const getChallengerRewardDice = (challengerId: string): DiceType[] => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? config.rewardDice : [];
};

// 获取挑战者奖励概率
export const getChallengerRewardProbability = (challengerId: string): number => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? config.rewardProbability : 0;
};

// 随机获取挑战者奖励骰子
export const getRandomChallengerRewardDice = (challengerId: string): DiceType | null => {
  const config = CHALLENGER_CONFIGS[challengerId];
  if (!config || !config.rewardDice.length) return null;

  if (Math.random() > config.rewardProbability) return null;

  const randomIndex = Math.floor(Math.random() * config.rewardDice.length);
  return config.rewardDice[randomIndex];
};

// 获取挑战者下注金额
export const getChallengerBetAmount = (challengerId: string): number => {
  const config = CHALLENGER_CONFIGS[challengerId];
  return config ? config.betAmount : 50;
};
